import * as React from 'react';
import { Image } from '@cian/ui-kit';

interface INewbuildingImageProps {
  url?: string;
  alt?: string;
  type: 'l' | 'xs';
}

export const HeaderImage: React.FC<INewbuildingImageProps> = ({ url, alt, type }) => {
  const width = React.useMemo(() => (type === 'xs' ? '56px' : '100%'), [type]);
  const height = React.useMemo(() => (type === 'xs' ? '56px' : '100%'), [type]);

  return <Image borderRadius="4px" objectFit="contain" src={url || ''} alt={alt} width={width} height={height} />;
};
